import AdminHeader from "../../component/AdminHeader";
import Icons from "../../myIcon/Icons";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { useEffect, useState } from "react";

const dashboardListEndpoint = ApiEndpoints.Dashboard.List;
const MonthlyEndpoint = ApiEndpoints.Dashboard.monthlycount;

export default function Dashboard() {
    const [leadsCount, setLeadsCount] = useState();
    const [tempCount, setTempCount] = useState();
    const [selectedMonth, setSelectedMonth] = useState({
        partner_form_count: "",
        contact_form_count: "",
        landing_form_count: "",
        blog_count: "",
        seo_count: "",
        project_count: "",
        job_count: "",  
        referral_count: "",
    });

    const getLeadsCount = async () => {
        try {
            const response = await ApiRequest("GET", dashboardListEndpoint);
            setLeadsCount(response);
            setTempCount(response);
        } catch (error) {
            console.error("Error fetching leads count:", error);
        }
    }

    useEffect(() => {
        getLeadsCount();
    }, []);


    // monthly 
    const handleChange = async (e) => {
        const { name, value } = e.target;

        if (value !== "") {
            setSelectedMonth((prev) => ({
                ...prev,
                [name]: value,
            }));
            try {
                const response = await ApiRequest("GET", `${MonthlyEndpoint}/${value}`);
                setLeadsCount((prev) => ({
                    ...prev,
                    [name]: response[name],
                }));
            } catch (error) {
                console.error("Error fetching leads count:", error);
            }
        } else {
            setLeadsCount((prev) => ({
                ...prev,
                [name]: tempCount[name],
            }));
            setSelectedMonth((pre) => ({
            ...pre,
            [name]: "",
        }))
        }
    };

    const handleRefresh = async (name) => {
        setLeadsCount((prev) => ({
            ...prev,
            [name]: tempCount[name],
        }));

        setSelectedMonth((pre) => ({
            ...pre,
            [name]: "",
        }))
    };

    const year = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const options = [
        { value: year + "-01", title: "January" },
        { value: year + "-02", title: "February" },
        { value: year + "-03", title: "March" },
        { value: year + "-04", title: "April" },
        { value: year + "-05", title: "May" },
        { value: year + "-06", title: "June" },
        { value: year + "-07", title: "July" },
        { value: year + "-08", title: "August" },
        { value: year + "-09", title: "September" },
        { value: year + "-10", title: "October" },
        { value: year + "-11", title: "November" },
        { value: year + "-12", title: "December" }
    ];

    const dropData = options.filter((item) => {
        const month = item.value.split("-").map(Number)[1];
        return month <= currentMonth;
    });

    const pagename = {
        name: 'Dashboard',
        user: 'Admin',
        innerpage: 'Dashboard'
    }

    return (
        <>
            <AdminHeader pagename={pagename} />
            <div className="add-btn-section">
                <div className="row">
                    <div class="col-lg-4">
                        <div class="home-dashbox grey-card">
                            <div class="dashbox-month">
                                <span>Total Blogs</span>
                                <div>
                                    <select
                                        value={selectedMonth.blog_count}
                                        onChange={handleChange}
                                        name="blog_count" >
                                        <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("blog_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.blog_count}</h4>
                            <div class="dashbox-link">
                                <p>Blogs</p>
                                <Link to="/blog">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="home-dashbox pink-card">
                            <div class="dashbox-month">
                                <span>Total Projects</span>
                                <div>
                                    <select
                                        value={selectedMonth.project_count}
                                        onChange={handleChange}
                                        name="project_count"   >
                                        <option  value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("project_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.project_count}</h4>
                            <div class="dashbox-link">
                                <p>Projects</p>
                                <Link to="/project">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="home-dashbox purple-card">
                            <div class="dashbox-month">
                                <span>Total Jobs Posted</span>
                                <div>
                                    <select
                                        value={selectedMonth.job_count}
                                        onChange={handleChange}
                                        name="job_count"   >
                                        <option  value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("job_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.job_count}</h4>
                            <div class="dashbox-link">
                                <p>Career</p>
                                <Link to="job">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="home-dashbox orange-card">
                            <div class="dashbox-month">
                                <span>Total SEO</span>
                                <div>
                                    <select value={selectedMonth.seo_count} onChange={handleChange} name="seo_count"  >
                                        <option  value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("seo_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.seo_count}</h4>
                            <div class="dashbox-link">
                                <p>SEO</p>
                                <Link to="/seo">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>
                   
                    <div class="col-lg-4">
                        <div class="home-dashbox green-card">
                            <div class="dashbox-month">
                                <span>Total Contact Leads</span>
                                <div>
                                    <select
                                        value={selectedMonth.contact_form_count}
                                        onChange={handleChange}
                                        name="contact_form_count"   >
                                        <option  value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("contact_form_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.contact_form_count}</h4>
                            <div class="dashbox-link">
                                <p>Contact Us</p>
                                <Link to="/contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="home-dashbox blue-card">
                            <div class="dashbox-month">
                                <span>Total Partner Leads</span>
                                <div>
                                    <select
                                        value={selectedMonth.partner_form_count}
                                        onChange={handleChange}
                                        name="partner_form_count"   >
                                        <option  value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("partner_form_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.partner_form_count}</h4>
                            <div class="dashbox-link">
                                <p>Partner With Us</p>
                                <Link to="/partner-with-us">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="home-dashbox yellow-card">
                            <div class="dashbox-month">
                                <span>Total Referral Leads</span>
                                <div>
                                    <select
                                        value={selectedMonth.referral_count}
                                        onChange={handleChange}
                                        name="referral_count"   >
                                        <option  value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("referral_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.referral_count}</h4>
                            <div class="dashbox-link">
                                <p>PMS Referral</p>
                                <Link to="/referral">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="home-dashbox aqua-card">
                            <div class="dashbox-month">
                                <span>Total Landing Leads</span>
                                <div>
                                    <select
                                        value={selectedMonth.landing_form_count}
                                        onChange={handleChange}
                                        name="landing_form_count"   >
                                        <option  value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("landing_form_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.landing_form_count}</h4>
                            <div class="dashbox-link">
                                <p>Landing Page</p>
                                <Link to="/landing-page">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}